var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDocIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_4206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3053 1.05615H4.72367C4.54832 1.05615 4.38014 1.12581 4.25615 1.2498C4.13216 1.3738 4.0625 1.54197 4.0625 1.71732V4.52815L10.0145 6.26415L15.9665 4.52815V1.71732C15.9665 1.54197 15.8968 1.3738 15.7728 1.2498C15.6489 1.12581 15.4807 1.05615 15.3053 1.05615Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9665 4.53271H4.0625V8.00471L10.0145 9.74071L15.9665 8.00471V4.53271Z",
    fill: "#2B7CD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9665 8.00146H4.0625V11.4735L10.0145 13.2095L15.9665 11.4735V8.00146Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9665 11.4702H4.0625V14.281C4.0625 14.4564 4.13216 14.6246 4.25615 14.7486C4.38014 14.8726 4.54832 14.9422 4.72367 14.9422H15.3053C15.4807 14.9422 15.6489 14.8726 15.7728 14.7486C15.8968 14.6246 15.9665 14.4564 15.9665 14.281V11.4702Z",
    fill: "#103F91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.36133 3.54053H4.0625V12.9645H8.36133C8.53652 12.964 8.70439 12.8942 8.82827 12.7703C8.95215 12.6464 9.02198 12.4786 9.0225 12.3034V4.2017C9.02198 4.0265 8.95215 3.85864 8.82827 3.73476C8.70439 3.61088 8.53652 3.54105 8.36133 3.54053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.86533 4.03271H4.0625V13.4567H7.86533C8.04052 13.4562 8.20839 13.3864 8.33227 13.2625C8.45615 13.1386 8.52598 12.9707 8.5265 12.7955V4.69388C8.52598 4.51869 8.45615 4.35082 8.33227 4.22694C8.20839 4.10306 8.04052 4.03324 7.86533 4.03271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.86533 4.03271H4.0625V12.4647H7.86533C8.04052 12.4642 8.20839 12.3944 8.33227 12.2705C8.45615 12.1466 8.52598 11.9787 8.5265 11.8035V4.69388C8.52598 4.51869 8.45615 4.35082 8.33227 4.22694C8.20839 4.10306 8.04052 4.03324 7.86533 4.03271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.36933 4.03271H4.0625V12.4647H7.36933C7.54452 12.4642 7.71239 12.3944 7.83627 12.2705C7.96015 12.1466 8.02998 11.9787 8.0305 11.8035V4.69388C8.02998 4.51869 7.96015 4.35082 7.83627 4.22694C7.71239 4.10306 7.54452 4.03324 7.36933 4.03271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.758824 4.03271H7.37249C7.54784 4.03271 7.71601 4.10237 7.84 4.22637C7.964 4.35036 8.03366 4.51853 8.03366 4.69388V11.3075C8.03366 11.4829 7.964 11.6511 7.84 11.7751C7.71601 11.8991 7.54784 11.9687 7.37249 11.9687H0.758824C0.583472 11.9687 0.415301 11.8991 0.291308 11.7751C0.167315 11.6511 0.0976563 11.4829 0.0976563 11.3075L0.0976562 4.69388C0.0976562 4.51853 0.167315 4.35036 0.291308 4.22637C0.415301 4.10237 0.583472 4.03271 0.758824 4.03271Z",
    fill: "#185ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02368 10.4771H5.13088L4.08928 7.05469L2.99808 10.4771H2.10528L1.11328 5.51709H2.00608L2.70048 8.98909L3.74208 5.61629H4.48608L5.47808 8.98909L6.17248 5.51709H7.01568L6.02368 10.4771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_4206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.872,
    fill: "white",
    transform: "translate(0 0.0639648)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/doc-icon.aeb13aa0.svg";
export { ForwardRef as ReactComponent };